// extracted by mini-css-extract-plugin
export default {"ignore_pointer_events":"Graph_ignore_pointer_events__3AA15"};